// src/utils/aes-encryption.ts
import CryptoJS from 'crypto-js';

const IV = CryptoJS.enc.Hex.parse('00000000000000000000000000000000'); // 16-byte IV (zero)

function encrypt(key: string, json: Record<string, any>) {
  const jsonString = JSON.stringify(json);
  const hashedKey = CryptoJS.SHA256(key);

  const encrypted = CryptoJS.AES.encrypt(jsonString, hashedKey, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString(); // Base64 encoded
}

function decrypt(key: string, base64CipherText: string) {
  const hashedKey = CryptoJS.SHA256(key);

  const decrypted = CryptoJS.AES.decrypt(base64CipherText, hashedKey, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedText);
}

export { encrypt, decrypt };
